import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../../constants';
import { IApiKey, IApiKeyResponse, IApiKeysResponse } from '../../types';

const SERVER_URL = API_CONFIG.SERVER_URL;

// Create axios instance with default config
const api: AxiosInstance = axios.create({
    baseURL: SERVER_URL,
});

// Add request interceptor to include token in headers
api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid, redirect to login
            localStorage.removeItem(STORAGE_KEYS.TOKEN);
            localStorage.removeItem(STORAGE_KEYS.USER);
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

// Generate API key
export const generateApiKey = async (): Promise<string> => {
    try {
        const response = await api.get<IApiKeyResponse>('/api-keys/generate');
        return response.data.apiKey;
    } catch (error) {
        console.error('Error generating API key:', error);
        throw error;
    }
};

// Get API key
export const getApiKey = async (): Promise<IApiKey | null> => {
    try {
        const response = await api.get<IApiKeysResponse>('/api-keys/');
        return response.data.apiKeys;
    } catch (error) {
        console.error('Error fetching API key:', error);
        throw error;
    }
}; 